class NewRelicPusher {
  constructor () {
    if (!NewRelicPusher.instance) {
      NewRelicPusher.instance = this
    }
    return NewRelicPusher.instance
  }

  registerNewRelicCustomLog (message, context, customAttributes) {
    if (!message || !context) return
    if (window.newrelic) {
      window.newrelic.addPageAction('CustomLog', {
        message,
        level: 'info',
        context,
        customAttributes
      })
    }
  }
}

const pusherNewRelic = new NewRelicPusher()
Object.freeze(pusherNewRelic)
export default pusherNewRelic
